import React from 'react';
import './SearchBar.css';

export default function SearchBar({ value, onChange, lang, resultCount, totalCount }) {
  const L = (en, hi) => lang === 'en' ? en : hi;
  return (
    <div className="search-bar">
      <div className="search-input-wrap">
        <span className="search-icon">⌕</span>
        <input className="search-input" type="text" value={value} onChange={e => onChange(e.target.value)}
          placeholder={L('Search temples, cities, deities…','मंदिर, शहर, देवता खोजें…')} />
        {value && <button className="search-clear" onClick={() => onChange('')}>✕</button>}
      </div>
      {totalCount > 0 && (
        <span className="search-count">
          {resultCount === totalCount ? L(`${totalCount} sites`,`${totalCount} स्थल`) : L(`${resultCount} of ${totalCount}`,`${totalCount} में से ${resultCount}`)}
        </span>
      )}
    </div>
  );
}
